<span #focus tabindex="0">{{textValue}}</span
><i
  class="bfx-field-icon-end bfx-ignore-target fa fa-fw icon-calendar_month"
  alt="Amend Value Date"
  title="Amend Value Date"
></i>
<p-calendar
  #dfCalendar
  [patchDragAutoclose]="dfCalendar"
  [patchPCalendarIcon]="dfCalendar"
  [ownerDocumentPCalendar]="dfCalendar"
  [(ngModel)]="value"
  (ngModelChange)="onModelChange($event)"
  icon="fa icon-calendar_month"
  name="df-calendar"
  [appendTo]="'body'"
  [disabledDays]="[0,6]"
  [minDate]="minDate"
  panelStyleClass="bfx-calendar__dropdown__container bfx-calendar-sm"
  dataType="date"
  ngDefaultControl
  dateFormat="dd-M-yy"
  (onSelect)="onSelect($event)"
></p-calendar>
